import React, { Fragment } from 'react';

const MentorStreamSchedule = () => {
  return (
    <Fragment>
      <div className="stream-section-container">
        <div className="padding-container">
          <div className="title-container-info">
            <div className="border-alt red">
              <p className="online-title-alt red">Stream Schedule</p>
            </div>
          </div>
          <ul className="stream-container-items-alt">
            <li className="stream-container-item">
              Sunday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              Offline
            </li>
            <li className="stream-container-item">
              Monday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              5pm EST - 9pm EST
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              Discussion about a very interesting topic
            </li>
            <li className="stream-container-item">
              Tuesday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              1pm EST - 9pm EST
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              Discussion about a very interesting topic
            </li>
            <li className="stream-container-item">
              Wednesday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              1pm EST - 9pm EST
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              NEW COURSE PREVIEW!
            </li>
            <li className="stream-container-item">
              Thursday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              1pm EST - 9pm EST
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              NEW COURSE RELEASE!
            </li>
            <li className="stream-container-item">
              Friday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              1pm EST - 9pm EST
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              Discussion about a very interesting topic
            </li>
            <li className="stream-container-item">
              Saturday
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              12pm EST - 8pm EST
              <i className="fas fa-long-arrow-alt-right red mx-5"></i>
              Live Link discussions!
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default MentorStreamSchedule;
